export default {
  data(){
    return {
      officeTutorial      : {
        options : {
          useKeyboardNavigation: false,
          labels: {
            buttonSkip: 'スキップ',
            buttonPrevious: '前へ',
            buttonNext: '次へ',
            buttonStop: '終了する'
          }
        },

        callbacks : {
          onSkip : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'office',
              value : false
            });
          },

          onFinish : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'office',
              value : false
            });

            if(this.tourType === 'through'){
              this.$store.dispatch({
                type  : 'tutorial/updateShouldOpenTour',
                name  : 'park'
              });
            }
          }
        },

        steps : [
          {
            target: '.pa-message-app-editor-editor-box',
            content: `ここは事務所です。事務所では異世界地球より電子的異界舞踏会へ御接続の皆様の為の各種御手続等をご提供致しております。`
          },
          
          {
            target: '.pa-message-app-editor-editor-box > .editor-set > .button-field',
            content: `発言ボタンより２４区番外地管理局の職員、森飼へ御遠慮なく御話掛け下さい。各種お手続を行わせていただきます。`
          }
        ]
      }
    }
  },

  watch : {
    tourType : {
      handler(value){
        // let newSteps = [];
        let stopButtonLabel = '終了する';

        switch(value){
          case 'single':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 7);

            stopButtonLabel = '終了する';
          break;

          case 'through':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 8);

            stopButtonLabel = '次へ';
          break;
        }

        // this.officeTutorial.steps = newSteps;
        this.officeTutorial.options.labels.buttonStop = stopButtonLabel;
      },
      immediate: true,
      deep: true
    }
  }
}